
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"}},_vm.$listeners),[_c('path',{attrs:{"d":"M7 13a1 1 0 0 1-.707-.293l-4-4a1 1 0 0 1 1.414-1.414l3.236 3.236 5.3-6.179a1 1 0 0 1 1.518 1.3l-6 7a1 1 0 0 1-.721.349Z"}})])}
var staticRenderFns = []

    export default {
      render: render,
    }
  